import React from 'react';
import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

// Vertical section navigation + revision jumps (desktop).
export const WizardSidebar = ({ sections, onJump, progress }) => {
  return (
    <aside className="hidden flex-col border-r border-border bg-secondary/30 p-7 lg:flex">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.16em] text-primary">Pendaftaran Magang</p>
        <h2 className="mt-2 font-display text-xl font-bold leading-snug text-foreground">
          Lengkapi profil lamaranmu
        </h2>
      </div>

      <div className="mt-5">
        <div className="mb-1.5 flex items-center justify-between text-xs text-muted-foreground">
          <span>Progres</span>
          <span className="font-semibold text-foreground">{progress}%</span>
        </div>
        <div className="h-1.5 w-full overflow-hidden rounded-full bg-border">
          <div className="h-full rounded-full bg-gradient-brand transition-all duration-500" style={{ width: `${progress}%` }} />
        </div>
      </div>

      <nav className="mt-7 space-y-0.5">
        {sections.map((s, i) => {
          const clickable = s.clickable;
          return (
            <button
              key={s.name}
              disabled={!clickable}
              onClick={() => clickable && onJump(s.firstIndex)}
              className={cn(
                'group flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left transition-colors',
                s.status === 'active' && 'bg-card shadow-card',
                clickable ? 'cursor-pointer hover:bg-card/70' : 'cursor-default'
              )}
            >
              <span
                className={cn(
                  'grid h-7 w-7 shrink-0 place-items-center rounded-full border text-[11px] font-semibold transition-colors',
                  s.status === 'done' && 'border-transparent bg-gradient-brand text-primary-foreground',
                  s.status === 'active' && 'border-primary text-primary',
                  s.status === 'todo' && 'border-border text-muted-foreground'
                )}
              >
                {s.status === 'done' ? <Check className="h-3.5 w-3.5" strokeWidth={3} /> : i + 1}
              </span>
              <span
                className={cn(
                  'text-sm transition-colors',
                  s.status === 'active' ? 'font-semibold text-foreground' : s.status === 'done' ? 'text-foreground/80' : 'text-muted-foreground'
                )}
              >
                {s.name}
              </span>
            </button>
          );
        })}
      </nav>

      <div className="mt-auto rounded-2xl border border-border bg-card p-4">
        <p className="text-xs leading-relaxed text-muted-foreground">
          Bisa bolak-balik kapan saja. Klik bagian mana pun di atas untuk merevisi jawabanmu. Datamu tersimpan otomatis di perangkat ini.
        </p>
      </div>
    </aside>
  );
};
